/**
 * @typedef { import('./EventWebinarDetail').Presenter } Presenter
 */

import styled from 'styled-components';
import { device } from '../../../utils/styled-component-mixins';

const Name = styled.p`
  font-size: 2.2rem;
  font-weight: 800;
  line-height: 3.2rem;
  margin: 0;

  @media ${device.deviceOnly} {
    font-size: 2rem;
    line-height: 2.4rem;
  }
`;

const Title = styled.p`
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 2.4rem;
  margin: 0;
`;

/**
 * @param {Presenter}
 * @returns {ReactElement}
 */
const Presenter = ({ className, link, name, title }) => {
  const linkProps = link
    ? {
        href: link,
        as: 'a',
        target: '_blank',
        rel: 'noopener noreferrer'
      }
    : {};

  return (
    <div className={className}>
      <Name {...linkProps}>{name}</Name>
      <Title>{title}</Title>
    </div>
  );
};

const StyledPresenter = styled(Presenter)`
  padding: 0 1.6rem !important; // Overrides accordion styles
  margin-block: 2.4rem;

  @media ${device.deviceOnly} {
    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export default StyledPresenter;
